import { formatDate, ListProviderDocumentsRequest, ProviderDisplayDocumentType, ProviderDocument } from '@enter/core';
import { faker } from '@faker-js/faker';
import _ from 'lodash';
import { ClaimGenerator } from './claim.generator';
import { IItemListing } from './root.store';
import { waitForNoReason } from './util';
import { generateAddress, generateItemListing } from './util.generator';

export class DocumentGenerator {
    private claimGenerator: ClaimGenerator;
    public documents: ProviderDocument[] = [];

    // TODO: extract index/storeTo/loadFrom as utility class
    public index: Map<string, Map<string, string[]>> = new Map<string, Map<string, string[]>>();

    constructor(claimGenerator: ClaimGenerator) {
        this.claimGenerator = claimGenerator;
        this.generateEntities(11);
    }

    public async loadDocumentListing(
        lpgr: ListProviderDocumentsRequest,
    ): Promise<IItemListing<ProviderDocument> | undefined> {
        await waitForNoReason(400);
        return generateItemListing(lpgr, this.documents);
    }

    private generateEntities(count: number = 3): void {
        _.times(count, () => this.generateProviderDocument());
    }

    private generateProviderDocument(id: string = faker.string.uuid()): ProviderDocument {
        const claim = _.sample(this.claimGenerator.claims);

        const isFax = Math.random() > 0.5;

        const created = faker.date.past();

        const document = {
            id,
            created: formatDate('Date')(created),
            organization: faker.company.name(),
            first: faker.person.firstName(),
            middle: _.sample([undefined, faker.person.firstName()]),
            last: faker.person.lastName(),
            suffix: _.sample([undefined, faker.person.suffix()]),
            addresses: _.times(_.random(0, 2), () => generateAddress()),
            phone: faker.phone.number(),
            dob: formatDate('Date')(faker.date.past()),
            email: faker.internet.exampleEmail(),
            groupId: _.uniqueId('group'),
            claimId: _.get(claim, 'id') as string,
            documentType: isFax ? ProviderDisplayDocumentType.FAX : ProviderDisplayDocumentType.CMS1500,
            filename: `Monthly Financial Report ${formatDate('MonthDayYear')(created)}.xls`,
        };
        this.documents.push(document);
        return document;
    }
}
